import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import otp_template from '~/templates/otp.handlebars';
import GeneralView from '~/generalView';

var OTPView = GeneralView.View.extend({
    tagName: "div",
    className: 'otpView',
    events: {
      'click #otpclosebutton' : 'close'
    },

    initialize: function(options) {
        this.options = options;
        _.bindAll(this, 'render');
    },

    render: function () {
      var handlebarsTemplate = Handlebars.template(otp_template);
      this.$el.html(handlebarsTemplate({}));
      this.$el.find('#otp-modal').modal('show');
    },

    close: function (){
      var value = this.$el.find('#inputotp').val();
      var func = this.options.callback;
      if(func) func(value);
      this.$el.find('#inputotp').val("");
      this.$el.find('#otp-modal').modal('hide');
    }

});
export default OTPView;
